import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { PureComponent } from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import sbSpinner from '../images/sb-spinner.gif';
import christmasSpinner from '../images/seasonalSpinners/sb-spinner-Christmas.gif';
import easterSpinner from '../images/seasonalSpinners/sb-spinner-Easter.gif';
import fireworksSpinner from '../images/seasonalSpinners/sb-spinner-Fireworks.gif';
import halloweenSpinner from '../images/seasonalSpinners/sb-spinner-Halloween.gif';
import saintPattySpinner from '../images/seasonalSpinners/sb-spinner-SaintPatty.gif';
import thanksgivingSpinner from '../images/seasonalSpinners/sb-spinner-Thanksgiving.gif';
import valentinesSpinner from '../images/seasonalSpinners/sb-spinner-Valentines.gif';
import { checkHoliday, NEW_YEARS, VALENTINES, EASTER, ST_PATRICKS, FOURTH_OF_JULY, HALLOWEEN, THANKSGIVING, CHRISTMAS } from '../util/holidays';
export default class SeasonalSpinner extends PureComponent {
  getLoadingImage() {
    let holiday = this.props.holiday;
    if (!holiday && this.props.useSeasonal) {
      const todaysHoliday = checkHoliday(new Date());
      holiday = todaysHoliday ? todaysHoliday : null;
    }
    switch (holiday) {
      case NEW_YEARS:
        return fireworksSpinner;
      case VALENTINES:
        return valentinesSpinner;
      case ST_PATRICKS:
        return saintPattySpinner;
      case EASTER:
        return easterSpinner;
      case FOURTH_OF_JULY:
        return fireworksSpinner;
      case HALLOWEEN:
        return halloweenSpinner;
      case THANKSGIVING:
        return thanksgivingSpinner;
      case CHRISTMAS:
        return christmasSpinner;
      default:
        return sbSpinner;
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(LoadingSpinner, _extends({}, this.props, {
      loadingImage: this.getLoadingImage()
    }));
  }
}
_defineProperty(SeasonalSpinner, "defaultProps", {
  className: '',
  width: '128px',
  holiday: null,
  useSeasonal: false
});